(() => {
  const formSelector = '.js-instalments-form';
  const termsSelector = 'shopify-payment-terms';
  const dataSelector = '.js-vat-payment-terms-data';

  function parseMoney(value) {
    if (typeof value !== 'string') return null;

    const normalized = value.replace(/[^0-9.,-]/g, '').replace(/,/g, '');
    const amount = Number.parseFloat(normalized);

    return Number.isFinite(amount) ? Math.round(amount * 100) : null;
  }

  function formatMoney(minorUnits, currency) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {
        style: 'currency',
        currency,
        currencyDisplay: 'narrowSymbol',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(minorUnits / 100);
    } catch (error) {
      return `£${(minorUnits / 100).toFixed(2)}`;
    }
  }

  function readPricingData(form) {
    const dataElement = form.querySelector(dataSelector);
    if (!dataElement) return null;

    try {
      return JSON.parse(dataElement.textContent);
    } catch (error) {
      console.warn('[VAT pricing] Unable to read Shop Pay pricing data.', error);
      return null;
    }
  }

  function correctPaymentTerms(form) {
    const terms = form.querySelector(termsSelector);
    if (!terms || terms.dataset.vatPriceAdjusted === 'true') return;

    const pricingData = readPricingData(form);
    const rawMetadata = terms.getAttribute('shopify-meta');
    if (!pricingData || pricingData.taxesIncluded || !rawMetadata) return;

    let metadata;
    try {
      metadata = JSON.parse(rawMetadata);
    } catch (error) {
      console.warn('[VAT pricing] Unable to read Shopify payment terms.', error);
      return;
    }

    if (!Array.isArray(metadata.variants)) return;

    const pricesByVariant = new Map(
      pricingData.variants.map((variant) => [String(variant.id), variant])
    );
    const minimumPrice = parseMoney(metadata.min_price);
    const maximumPrice = parseMoney(metadata.max_price);
    let changed = false;

    metadata.variants.forEach((variant) => {
      const pricing = pricesByVariant.get(String(variant.id));
      if (!pricing?.taxable || !Number.isFinite(pricing.priceIncludingVatMinor)) return;

      const fullPrice = pricing.priceIncludingVatMinor;
      variant.full_price = formatMoney(fullPrice, pricingData.currency || metadata.currency_code || 'GBP');
      variant.price_per_term = formatMoney(
        Math.round(fullPrice / (variant.number_of_payment_terms || 3)),
        pricingData.currency || metadata.currency_code || 'GBP'
      );

      if (minimumPrice !== null && maximumPrice !== null) {
        variant.eligible = fullPrice >= minimumPrice && fullPrice <= maximumPrice;
      }

      changed = true;
    });

    if (!changed) return;

    terms.dataset.vatPriceAdjusted = 'true';
    terms.setAttribute('shopify-meta', JSON.stringify(metadata));
  }

  function initialise(root = document) {
    if (root.matches?.(formSelector)) correctPaymentTerms(root);
    root.querySelectorAll?.(formSelector).forEach(correctPaymentTerms);
  }

  function start() {
    initialise();

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) initialise(node);
        });
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
